//Include Both Helper File with needed methods
import { getFirebaseBackend } from "../../../helpers/firebase_helper";
import {
  postFakeLogin,
  postJwtLogin,
  postSocialLogin,
} from "../../../api";
import { clearAuthorization, setAuthorization } from "../../../api/config";

import { loginSuccess, logoutUserSuccess, apiError, reset_login_flag } from './reducer';

export const loginUser = (user, history) => async (dispatch) => {
  try {
    let response;
    const authType = process.env.REACT_APP_DEFAULTAUTH || "jwt";
    if (authType === "firebase") {
      let fireBaseBackend = getFirebaseBackend();
      response = fireBaseBackend.loginUser(
        user.email,
        user.password
      );
    } else if (authType === "jwt") {
      response = postJwtLogin({
        email: user.email,
        password: user.password
      });
    } else {
      response = postFakeLogin({
        email: user.email,
        password: user.password
      });
    }

    var data = await response;

    if (data) {
      // Extract role from backend response
      // Backend should return: { role: "admin" | "seller", ... } or nested in data.user.role
      let userRole = null;
      let finalData = null;
      
      // Handle different response structures
      if (data.data && typeof data.data === 'object') {
        // Response wrapped in { data: {...} }
        userRole = data.data.role || data.data.user?.role || data.role || "admin";
        finalData = { ...data.data, role: userRole };
      } else if (data.user) {
        // Response with nested user object
        userRole = data.user.role || data.role || "admin";
        finalData = { ...data.user, ...data, role: userRole };
      } else {
        // Direct user object response
        userRole = data.role || "admin";
        finalData = { ...data, role: userRole };
      }

      // Ensure token is included (might be accessToken or token)
      if (!finalData.token && finalData.accessToken) {
        finalData.token = finalData.accessToken;
      }

      // Store in localStorage for persistence
      localStorage.setItem("authUser", JSON.stringify(finalData));
      if (finalData.token) {
        setAuthorization(finalData.token);
      }
      dispatch(loginSuccess(finalData));

      // Redirect based on role from backend response
      const redirectPath = userRole === "seller" ? "/seller/dashboard" : "/dashboard";
      if (typeof history === "function") {
        history(redirectPath);
      } else {
        window.location.href = redirectPath;
      }
    }
  } catch (error) {
    dispatch(apiError(error));
  }
};

export const logoutUser = (history = null) => async (dispatch) => {
  try {
    // Clear authorization header
    clearAuthorization();
    
    // Clear all localStorage items (cache)
    localStorage.clear();
    
    // Also clear sessionStorage if any items exist
    sessionStorage.clear();
    
    // Clear Firebase auth if using Firebase
    let fireBaseBackend = getFirebaseBackend();
    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const response = fireBaseBackend.logout;
      dispatch(logoutUserSuccess(response));
    } else {
      dispatch(logoutUserSuccess(true));
    }

    // Redirect to login page
    // Use window.location for a hard redirect to ensure cache is cleared
    window.location.href = '/login';

  } catch (error) {
    dispatch(apiError(error));
    // Even on error, redirect to login
    window.location.href = '/login';
  }
};

export const socialLogin = (type, history) => async (dispatch) => {
  try {
    let response;

    if (process.env.REACT_APP_DEFAULTAUTH === "firebase") {
      const fireBaseBackend = getFirebaseBackend();
      response = fireBaseBackend.socialLoginUser(type);
    }
    //  else {
      //   response = postSocialLogin(data);
      // }
      
      const socialdata = await response;
    if (socialdata) {
      localStorage.setItem("authUser", JSON.stringify(response));
      dispatch(loginSuccess(response));
      history('/dashboard')
    }

  } catch (error) {
    dispatch(apiError(error));
  }
};

export const resetLoginFlag = () => async (dispatch) => {
  try {
    const response = dispatch(reset_login_flag());
    return response;
  } catch (error) {
    dispatch(apiError(error));
  }
};
